import { createFileRoute } from "@tanstack/react-router";
import { Home } from "../home/Home.tsx";

export const Route = createFileRoute("/")({
  component: Home,
});
